<template>
  <BaseTypeIndexShell base-type="events" title="Veranstaltungen">
    <ContractContingent objectType="events" :activeObjectCount="activeMarketingObjects" />
    <ObjectsTable
      :objects="objects"
      base-type="events"
      :show-dates="true"
      :show-stats-action="true"
      :lazy="true"
      :rows="objectStore.serverOptions.rows"
      :total-records="totalRecords"
      :loading="objectStore.loading"
      @page="onPage"
    />
  </BaseTypeIndexShell>
</template>

<script>
import ObjectsTable from "@/components/objects/ObjectsTable.vue";
import {useObjectStore} from "@/stores/object";
import ContractContingent from "@/components/objects/ContractContingent.vue";
import BaseTypeIndexShell from "@/components/base_type/BaseTypeIndexShell.vue";

export default {
  components: {
    BaseTypeIndexShell,
    ContractContingent,
    ObjectsTable,
  },
  data() {
    return {
      objects: [],
      totalRecords: 0,
    }
  },
  setup() {
    return {
      objectStore: useObjectStore(),
    }
  },
  created() {
    this.getObjects()
  },
  methods: {
    normalizeObjects(data) {
      return Array.isArray(data) ? data : data?.objects || []
    },
    onPage(event) {
      this.objectStore.serverOptions = event
      this.getObjects()
    },
    getObjects() {
      this.objectStore.apiIndex(this.$route.meta.base_type, {paginated: true}).then(({data}) => {
        const objects = this.normalizeObjects(data)
        this.objects = objects
        this.totalRecords = Number(data?.totalRecords || objects.length)
      })
    },
  },
  computed: {
    activeMarketingObjects() {
      return this.normalizeObjects(this.objects).filter(o => o.setting_enable_in_manet_stadt_abl === true).length
    },
  },
}
</script>
